import { render, staticRenderFns } from "./SupplyItem.vue?vue&type=template&id=99ed0d6e&scoped=true"
import script from "./SupplyItem.vue?vue&type=script&lang=js"
export * from "./SupplyItem.vue?vue&type=script&lang=js"
import style0 from "./SupplyItem.vue?vue&type=style&index=0&id=99ed0d6e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ed0d6e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/SupplyItem.vue
// module id = 2149
// module chunks = 31